// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_37Xx_){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1bLUg .dualColumn_nyajZ{display:flex;align-content:space-between}.nsAddressForm_1bLUg .dualColumn_nyajZ .firstCol_611z_{margin-right:20px}.optional_2vFJf{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_37Xx_",
	"nsAddressForm": "nsAddressForm_1bLUg",
	"dualColumn": "dualColumn_nyajZ",
	"firstCol": "firstCol_611z_",
	"optional": "optional_2vFJf"
};
module.exports = exports;
